/* global jQuery */
void (function detailsFunctionality($) {
	'use strict';

	// Variables
	const $body = $('#Body');

	// Create dropdown function
	function addFunctionality(target) {
		// When clicking the dropdown heading
		$(target).on('click', (event) => {
			event.preventDefault();

			// Define details scope
			const $detailsElement = $(event.target).closest('details');
			const $detailsContent = $detailsElement.find('.details--content');

			// Check to see if details content is visible
			const contentIsVisible = $detailsElement[0].hasAttribute('open');

			// Show or hide content
			if (contentIsVisible) {
				$detailsElement.removeAttr('open');
				$detailsContent.hide();
			} else {
				$detailsElement.attr('open', '');
				$detailsContent.show();
			}
		});
	}

	// When page loads...
	$(document).ready(() => {
		// Find all the link lists and turn them into dropdowns
		$body.find('details').each((index, element) => {
			addFunctionality(element);
		});
	});
})(jQuery);
